export const SITE = {
  name: "HarmCheck",
  legalName: "Alphy",
  url: "https://www.harmcheck.com",
  defaultTitle: "HarmCheck — Enterprise Communication Compliance",
  titleTemplate: (pageTitle?: string) =>
    pageTitle ? `${pageTitle} | HarmCheck` : "HarmCheck — Enterprise Communication Compliance",
  defaultDescription:
    "HarmCheck is enterprise communication compliance software that prevents harmful or non-compliant messages before they're sent.",
  defaultOgImage: "/opengraph.jpg",
  logoPath: "/harmcheck-logo.png",
  twitter: "@alphy_co",
  social: {
    linkedin: "https://www.linkedin.com/company/alphyco/",
    twitter: "https://twitter.com/alphy_co",
    instagram: "https://www.instagram.com/alphy_co",
  },
  founded: "2025",
  founder: {
    name: "Julian Guthrie",
    linkedin: "https://www.linkedin.com/in/julian-guthrie-2ab33b141/",
  },
  addresses: [
    { city: "Palo Alto", region: "CA", country: "US" },
    { city: "Coeur d'Alene", region: "ID", country: "US" },
  ],
} as const;

export const ROUTES = {
  static: [
    "/",
    "/about",
    "/active-listening",
    "/rapid-deploy",
    "/restricted-list",
    "/why-harmcheck",
    "/harmcheck-vs-llms",
    "/case-studies",
    "/blog",
    "/faqs",
    "/support",
    "/book-a-demo",
    "/feedback/outlook",
    "/trust-privacy",
    "/trust-security",
    "/trust-responsible-ai",
    "/privacy-policy",
    "/terms-of-service",
  ],
} as const;
